import type { Environment } from './environment.model';

export const environment = {
  production: false,
  envName: 'stage',
  pendoPrefix: 'stage',
  apiBaseUrl: 'https://connect-stage.arinsights.com/api',
  autoLogoutMinutes: 60,
  app: {
    url: 'https://connect-stage.arinsights.com',
  },
  identityServer: {
    url: 'https://securestage.arinsights.com',
    clientId: 'arconnect',
  },
  architect: {
    url: 'https://architectstage.arinsights.com',
  },
  ckeditor: {
    licenseKey:
      'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3OTQwOTU5OTksImp0aSI6ImQ5MGFlZDA2LTYzMzMtNGRjNy1iM2FhLWRlYTkzZjg2M2M2YyIsImxpY2Vuc2VkSG9zdHMiOlsiKi5hcmluc2lnaHRzLm5ldCIsIiouYXJpbnNpZ2h0cy5jb20iXSwidXNhZ2VFbmRwb2ludCI6Imh0dHBzOi8vcHJveHktZXZlbnQuY2tlZGl0b3IuY29tIiwiZGlzdHJpYnV0aW9uQ2hhbm5lbCI6WyJjbG91ZCIsImRydXBhbCJdLCJ3aGl0ZUxhYmVsIjp0cnVlLCJmZWF0dXJlcyI6WyJEUlVQIiwiRE8iLCJGUCIsIlNDIiwiVE9DIiwiVFBMIiwiUE9FIiwiQ0MiLCJNRiIsIkUyUCIsIkUyVyIsIk1MTCIsIlNFRSIsIkVDSCIsIkVJUyIsIkxIIiwiRk9PIl0sInZjIjoiZjE2ZWUxZWQifQ.5yAvqhwtoJj_QQDQEx_D4TJ4zEu3R-Rw7__qJhXj8U4kLRAt5EugmioVXAWNnho8x2qt_xAxyR40seyaI6njhw',
  },
  intercom: {
    appId: 'azvl86u6',
  },
} as const satisfies Environment;
